<template>
  <v-btn
    block
    v-if="allowCncSwitch"
    color="blue darken-2"
    outlined
    large
    @click="switchCnc()"
    :loading="loading"
  >{{switchText}}</v-btn>
</template>

<script>
import { mapActions ,mapMutations} from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      loading: false
    };
  },
  computed: {
    switchText() {
      let text = "Switch to Click & Collect";

      if (this.$store.getters.retrieveIsCncCustomer) {
        text = "Switch to Home Delivery";
      }

      return text;
    },

    allowCncSwitch() {
      let cncSwitch = false;

      if (
        this.$store.getters.retrieveIsCashCustomer ||
        this.$store.getters.retrieveIsCncCustomer
      ) {
        if (
          this.$store.getters.retrieveCncOrdersEnabled &&
          !this.$store.getters.retrieveIsCncOnly
        ) {
          cncSwitch = true;
        }
      }

      return cncSwitch;
    }
  },

  methods: {
    ...mapActions(["getCustomer", "getTrollys"]),
    ...mapMutations(["setSelectedCustomer"]),

    async switchCnc() {
      this.loading = true;

      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey
      });
      const params = new URLSearchParams();
      params.append("params", stringPayload);

      await axios
        .post("switch-user-account-no", params)
        .then(response => {
          if (response.data.success) {
            console.log("Setting Customer No");
            this.$store.commit("setSelectedCustomer",response.data.accountNo);
            console.log("-- Get Customer");
          }
        })
        .catch(err => {
          console.log(err);
        });

      await this.getCustomer();
      await this.refreshBasket();

      this.loading = false;
    },

    async refreshBasket() {
      console.log("-- Close Popups");
      this.editBasketDialog = false;
      this.deleteItemDialog = false;

      console.log("-- Refresh Basket");
      await this.getTrollys()
        .then(response => {
          console.log("-- Got Trollys");
          console.log(response);
        })
        .catch(er => {
          console.log(er);
        });
    }
  }
};
</script>

<style lang="sass" scoped>
</style>